import React, { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import StableInput from "../../common/StableInput";
import { systemOptions } from "../../../constants";

const ConnectionDetails = ({
  connected,
  setConnected,
  sourceSystem,
  nextStep,
}) => {
  const [connectionDetails, setConnectionDetails] = useState({
    hostname: "",
    port: "",
    username: "",
    password: "",
    database: "",
  });
  const [isConnecting, setIsConnecting] = useState(false);

  const testConnection = () => {
    setIsConnecting(true);
    // Simulate connection test
    setTimeout(() => {
      setConnected(true);
      setIsConnecting(false);
    }, 1500);
  };

  const selectedSystem =
    systemOptions.find((sys) => sys.id === sourceSystem)?.name || "selected";

  return (
    <div className="mt-6 space-y-6">
      <h3 className="text-lg font-medium text-gray-900">Database Connection</h3>
      <p className="text-sm text-gray-500">
        Provide credentials for the {selectedSystem} system.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Hostname / Server
          </label>
          <StableInput
            initialValue={connectionDetails.hostname}
            onSave={(value) =>
              setConnectionDetails((prev) => ({ ...prev, hostname: value }))
            }
            placeholder="e.g., db.example.com"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Port
          </label>
          <StableInput
            initialValue={connectionDetails.port}
            onSave={(value) =>
              setConnectionDetails((prev) => ({ ...prev, port: value }))
            }
            placeholder="e.g., 1521"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Username
          </label>
          <StableInput
            initialValue={connectionDetails.username}
            onSave={(value) =>
              setConnectionDetails((prev) => ({ ...prev, username: value }))
            }
            placeholder="Database username"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Password
          </label>
          <StableInput
            initialValue={connectionDetails.password}
            onSave={(value) =>
              setConnectionDetails((prev) => ({ ...prev, password: value }))
            }
            placeholder="Database password"
            type="password"
          />
        </div>

        <div className="col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Database / Schema Name
          </label>
          <StableInput
            initialValue={connectionDetails.database}
            onSave={(value) =>
              setConnectionDetails((prev) => ({ ...prev, database: value }))
            }
            placeholder="e.g., HR_PROD"
          />
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <button
          type="button"
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={testConnection}
          disabled={connected || isConnecting}
        >
          {connected ? (
            <>
              <Check className="mr-2" size={16} />
              Connected Successfully
            </>
          ) : isConnecting ? (
            <>
              <Loader2 className="mr-2 animate-spin" size={16} />
              Connecting...
            </>
          ) : (
            "Test Connection"
          )}
        </button>

        {connected && (
          <div className="flex items-center gap-4">
            <p className="text-sm text-green-600">
              <Check className="inline mr-1" size={14} />
              Connection successful! Ready to begin analysis.
            </p>
            <button
              type="button"
              onClick={nextStep}
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              Proceed to Questionnaire
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConnectionDetails;
